import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/async";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  selectCountryOptions,
  selectVisibleCountryOptions
} from "../../store/slices/countryOptions";

// Country dropdown used everywhere a country is picked.
// - valueField "key": the form stores the option key (funnel companyInfo.country)
// - valueField "name": the form stores the German name (customer.country)
// Hidden options are not offered, but a hidden value that is already selected is
// shown with a "hidden" label. A value that matches no option is shown as it is.
const CountrySelectField = ({
  control,
  name,
  valueField = "key",
  fieldError = false
}) => {
  const { t } = useTranslation();
  const allCountryOptions = useSelector(selectCountryOptions);
  const visibleCountryOptions = useSelector(selectVisibleCountryOptions);

  const getOptionLabel = (option) =>
    option.hidden
      ? `${option.name} (${t("countries.statusHidden")})`
      : option.name;

  const loadOptions = async (inputValue) =>
    visibleCountryOptions.filter((country) =>
      country.name.toLowerCase().includes(inputValue.toLowerCase())
    );

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const selected = allCountryOptions.find(
          (country) => country[valueField] === field.value
        );
        return (
          <AsyncSelect
            className="w-100"
            placeholder={t("common.select")}
            defaultOptions={visibleCountryOptions}
            loadOptions={loadOptions}
            value={
              selected ||
              (field.value
                ? { [valueField]: field.value, name: field.value }
                : null)
            }
            onChange={(option) =>
              field.onChange(option ? option[valueField] : "")
            }
            onBlur={field.onBlur}
            getOptionLabel={getOptionLabel}
            getOptionValue={(option) => option[valueField]}
            styles={{
              control: (base) => ({
                ...base,
                borderColor: fieldError
                  ? "var(--danger-color)"
                  : "var(--field-border-color-regular)"
              })
            }}
          />
        );
      }}
    />
  );
};

export default CountrySelectField;
